export default {
    namespaced: true,

    state: {
        // E3
        systemSupportOptions: [
            'Clevis Hanger',
            'Flat Surface',
            'Roller Hanger',
        ],
        systemSupport: null,

        // E5
        temperatureRangeOptions: [
            '20° to 1200° F',
            '-300° to 250° F',
        ],
        temperatureRange: null,

        // E7
        hangerSpacingOptions: [
            "7' to 10'",
            "10'+",
        ],
        hangerSpacing: null,

        // E9
        flameRatingRequired: false,

        // E11
        copperTubeSizeOptions: [
            ['5/8', 5/8],
            ['7/8', 7/8],
            ['1-1/8', 1 + 1/8],
            ['1-3/8', 1 + 3/8],
            ['1-5/8', 1 + 5/8],
            ['2-1/8', 2 + 1/8],
            ['2-5/8', 2 + 5/8],
            ['3-1/8', 3 + 1/8],
            ['4-1/8', 4 + 1/8],
            ['5-1/8', 5 + 1/8],
            ['6-1/8', 6 + 1/8],
            ['8-1/8', 8 + 1/8],
        ],
        nominalPipeSizeOptions: [
            ['1/2', .5],
            ['3/4', .75],
            ['1', 1],
            ['1-1/4', 1.25],
            ['1-1/2', 1.5],
            ['2', 2],
            ['2-1/2', 2.5],
            ['3', 3],
            ['4', 4],
            ['5', 5],
            ['6', 6],
            ['8', 8],
            ['10', 10],
            ['12', 12],
            ['14', 14],
            ['15', 15],
            ['16', 16],
            ['17', 17],
            ['18', 18],
            ['19', 19],
            ['20', 20],
            ['21', 21],
            ['22', 22],
            ['23', 23],
            ['24', 24],
        ],
        nominalPipeSize: null,

        // E13
        pipeTypeOptions: [
            'Copper Tube',
            'Stainless Tube',
            'Black Steel (IPS)',
            'Cast Iron',
            'PPR Pipe',
            'Ductile Pipe',
            'Stainless Pipe',
        ],
        pipeType: null,

        // E15
        insulationThicknessOptions: [
            '1/2 "',
            '1 "',
            '1 1/2 "',
            '2 "',
            '2 1/2 "',
            '3 "',
            '3 1/2 "',
            '4 "',
            '4 1/2 "',
            '5 "',
            '5 1/2 "',
            '6 "',
        ],
        insulationThickness: null,

        possibleProducts: [
            {
                slug: 'PRO-SHIELD',
                name: 'Pro-Shield Thermal Hanger Shield',
                url: '/products/pro-shield-thermal-hanger-shield',
                image:'https://s3.us-east-1.amazonaws.com/ue1.asc-es.com/images/products/_productDetail/931847/5J8A5726_PS_exp_white-BG.webp'
            },
            {
                slug: 'QUIK-SHIELD',
                name: 'Quik-Shield Thermal Hanger Shield',
                url: '/products/quik-shield-thermal-hanger-shield',
                image: 'https://s3.us-east-1.amazonaws.com/ue1.asc-es.com/images/products/_productDetail/931866/quik-shield-1-800x431.webp'
            },
            {
                slug: 'CHILL-SHIELD',
                name: 'Chill-Shield Thermal Hanger Shield',
                url: '/products/chill-shield-thermal-hanger-shield',
                image: 'https://s3.us-east-1.amazonaws.com/ue1.asc-es.com/images/products/_productDetail/931868/5J8A5742_PS_exp_white-BG.webp'
            },
            {
                slug: 'MAXSPAN',
                name: 'Max-Span Thermal Hanger Shield',
                url: '/products/max-span-thermal-hanger-shield',
                image: 'https://s3.us-east-1.amazonaws.com/ue1.asc-es.com/images/products/_productDetail/931932/maxspan.webp'
            },
            {
                slug: 'MAXSPANRH',
                name: 'Max-Span Thermal Hanger for Roller Hangers',
                url: '/products/max-span-thermal-hanger-for-roller-hangers',
                image: 'https://s3.us-east-1.amazonaws.com/ue1.asc-es.com/images/products/_productDetail/931949/max-span-rh-460x295.webp'
            },
        ],

        typicalProducts: [ 'PRO-SHIELD', 'QUIK-SHIELD', 'CHILL-SHIELD' ],
    },

    getters: {
        // H3
        supportRecommendedProducts(state) {
            if (state.systemSupport === 'Roller Hanger') {
                if (state.temperatureRange === '20° to 1200° F') {
                    return ['MAXSPANRH']
                } else {
                    return []
                }
            } else {
                if (state.temperatureRange === '20° to 1200° F') {
                    return ['PRO-SHIELD', 'QUIK-SHIELD', 'MAXSPAN']
                } else {
                    return ['PRO-SHIELD', 'QUIK-SHIELD', 'CHILL-SHIELD', 'MAXSPAN']
                }
            }
        },

        // H7
        spacingRecommendedProducts(state) {
            if (state.hangerSpacing === "10'+") {
                if (state.systemSupport === 'Clevis Hanger') {
                    return []
                } else if (state.systemSupport === 'Roller Hanger') {
                    return ['MAXSPANRH']
                } else {
                    return ['MAXSPAN']
                }
            }

            return state.possibleProducts.map(p => p.slug)
        },

        // H9
        //=IF(AND(E11>14,E3="Clevis Hanger"),"UE11se MaxSpan",IF(AND(E3="Flat Surface",E11>14),"Use MaxSpanRH design",IF(AND(E3="Clevis Hanger",E11<16),"Pro, Quik, Chill-Shields are OK","")))
        flameRatingRecommendedProducts(state) {
            if (state.flameRatingRequired) {
                return state.possibleProducts.map(p => p.slug).filter(slug => slug !== 'CHILL-SHIELD')
            }
            return state.possibleProducts.map(p => p.slug)
        },

        // H11
        pipeSizeRecommendedProducts(state) {
            if (state.nominalPipeSize > 14) {
                return ['MAXSPAN', 'MAXSPANRH']
            }
            return state.possibleProducts.map(p => p.slug)
        },

        // H13
        pipeTypeRecommendedProducts(state) {
            if (state.pipeType === 'Ductile Pipe') {
                return []
            }

            return state.possibleProducts.map(p => p.slug)
        },

        surfaceRecommendation(state) {
            if (state.systemSupport === 'Flat Surface') {
                return "If secured by U-Bolt, add optional top shield."
            }
        },

        // H5
        temperatureRecommendation(state) {
            if (state.temperatureRange === '-300° to 250° F') {
                return "Urethane needed belowed 20° F, may be appropriate below ambient temperature. Above ambient Pro/Quik Shields are appropriate."
            }
        },

        // H15
        insulationRecommendation(state) {
            if (state.systemSupport === 'Clevis Hanger' && state.hangerSpacing === "10'+") {
                return 'Please contact sales for insulation recommendations.'
            } else if (state.nominalPipeSize > 23) {
                return 'Please contact sales for insulation recommendations.'
            } else if (state.pipeType === 'Ductile Pipe') {
                return 'Please contact sales for insulation recommendations.'
            }
            return ''
        },


        recommendedProductSlugs(state, getters) {
            return [
                state.possibleProducts.map(p => p.slug),
                getters.pipeTypeRecommendedProducts,
                getters.supportRecommendedProducts,
                getters.spacingRecommendedProducts,
                getters.flameRatingRecommendedProducts,
                getters.pipeSizeRecommendedProducts,
            ].reduce(
                    (acc, set) => acc.filter(p => set.includes(p)),
                    state.possibleProducts.map(p => p.slug)
                )
        },

        recommendedProducts(state, getters) {
            let slugs = getters.recommendedProductSlugs
            if (slugs.some(p => state.typicalProducts.includes(p))) {
                slugs = slugs.filter(p => state.typicalProducts.includes(p))
            }
            return state.possibleProducts.filter(p => slugs.includes(p.slug))
        },

        filledIn(state) {
            return state.pipeType
                && state.systemSupport
                && state.temperatureRange
                && state.hangerSpacing
                && state.nominalPipeSize
                && state.insulationThickness
        },

        pipeSizeOptions(state) {
            if (['Copper Tube', 'PPR Pipe'].includes(state.pipeType)) {
                return state.copperTubeSizeOptions
            } else {
                return state.nominalPipeSizeOptions
            }
        },
    },

    mutations: {
        setSystemSupport(state, systemSupport) {
            state.systemSupport = systemSupport
        },
        setTemperatureRange(state, temperatureRange) {
            state.temperatureRange = temperatureRange
        },
        setHangerSpacing(state, hangerSpacing) {
            state.hangerSpacing = hangerSpacing
        },

        setFlameRatingRequired(state, flameRatingRequired) {
            state.flameRatingRequired = flameRatingRequired
        },

        setNominalPipeSize(state, nominalPipeSize) {
            state.nominalPipeSize = nominalPipeSize
        },

        setPipeType(state, pipeType) {
            state.pipeType = pipeType
        },

        setInsulationThickness(state, insulationThickness) {
            state.insulationThickness = insulationThickness
        },
    },
}
